import { useEffect, useState } from 'react';

import Dialog from 'src/interfaces/dialog';
import dialogController from 'src/controller/dialogController';

import styles from './DialogProvider.module.scss';

interface Props {
  children?: React.ReactNode;
}

const DialogProvider = ({ children }: Props) => {
  const [dialogs, setDialogs] = useState<Dialog[]>([]);
  useEffect(() => {
    const addDialog = (dialog: Dialog) => {
      setDialogs((cur) => {
        const newDialogs = [...cur, dialog];
        return newDialogs;
      });
    };
    const popById = (id: string) => {
      setDialogs((cur) => {
        const newDialogs = cur.filter((dialog) => dialog.id !== id);
        return newDialogs;
      });
    };

    dialogController.onAddDialog(addDialog);
    dialogController.onPopById(popById);
    return () => {
      dialogController.offAddDialog(addDialog);
      dialogController.offPopById(popById);
    };
  }, []);

  useEffect(() => {
    const handleCheckId = (payload: { id: string; res: boolean }) => {
      payload.res = dialogs.some((dialog) => dialog.id === payload.id);
      return payload;
    };
    dialogController.onCheckId(handleCheckId);
    return () => {
      dialogController.offCheckId(handleCheckId);
    };
  }, [dialogs]);

  return (
    <>
      {children}
      <div></div>
      {dialogs.map(({ id, component }) => (
        <div key={id} className={styles.dialog}>
          {component}
        </div>
      ))}
    </>
  );
};

export default DialogProvider;
